import React from 'react';
import {Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap';
import {withRouter} from 'react-router-dom';

import Modal from '../../../../shared/components//Modals/Modal.jsx';
import OfferExampleDetail from '../../OfferExample/Detail/OfferExampleDetail.jsx';

class OfferExampleModal extends Modal {
  render() {
    const {closeModal, offer, ...props} = this.props;

    if (!offer) {
      return null;
    }

    return <BootstrapModal toggle={closeModal} isOpen={props.isOpen} className="modal-lg" backdrop="static">
      <ModalHeader toggle={closeModal}>{offer.title}</ModalHeader>
      <ModalBody>
        <OfferExampleDetail offer={offer} card={false}/>
        <button className="btn btn-primary d-block mx-auto" onClick={closeModal}>Fermer</button>
      </ModalBody>
    </BootstrapModal>;
  }
}

export default withRouter(OfferExampleModal);